const instances = new Map();

function onClickOutside(event, el, handler) {
  const isClickOutside = !event.contains(el.target);

  return isClickOutside ? handler(event, el.target) : null;
}

function toggleEventListeners(action, eventHandler) {
  document[`${action}EventListener`]("click", eventHandler, true);
}

export default {
  bind(el, {value: handler}) {
    const eventHandler = (event) => onClickOutside(el, event, handler);

    toggleEventListeners("add", eventHandler);

    instances.set(el, eventHandler);
  },

  unbind(el) {
    const eventHandler = instances.get(el);

    toggleEventListeners("remove", eventHandler);

    instances.delete(el);
  },
};
